import HQChart from 'hqchart'
import { quotePrice } from './quoteDisplay'

let tooltipInstalled = false

// HQChart's canvas prices share this instance formatter. Its legacy HTML
// K-line tooltip uses a separate public formatter registry, so adapt that too.
export function applyChartPricePrecision(chart) {
  const container = chart && chart.JSChartContainer
  if (container) {
    container.FormatPriceString = value => quotePrice(value)
    chart.AddEventCallback({
      event: HQChart.Chart.JS_ID.JSCHART_EVENT_ID.ON_FORMAT_INDEX_OUT_TEXT,
      callback(event, data) {
        if (data.FrameID === 0 && /^MA\d+$/.test(data.Item.Name)) {
          data.Out = { Text: quotePrice(data.Value), ArrayText: null }
        }
      }
    })
    // A repaint also covers data synchronously supplied from cache by SetOption.
    // Draw only paints existing data; it never requests a new quote.
    container.Draw()
  }

  if (tooltipInstalled) return
  const registry = HQChart.Chart.JSChart.GetDivTooltipDataFormat()
  const original = registry.DataMap.get('HistoryDataStringFormat')
  registry.DataMap.set('HistoryDataStringFormat', {
    Create() {
      const format = original.Create()
      const getTitle = format.GetFormatTitle
      format.GetFormatTitle = function (data) {
        const title = getTitle.call(this, data)
        // PC only offers daily/weekly/monthly K-lines, whose first four rows
        // are OHLC. Leave volume, amount and percentages in their native format.
        if (title && title.AryText && !data.IsNonTrade) {
          ;[data.Open, data.High, data.Low, data.Close].forEach((value, index) => {
            if (title.AryText[index]) title.AryText[index].Text = quotePrice(value)
          })
        }
        return title
      }
      return format
    }
  })
  tooltipInstalled = true
}
